import React, { useEffect, useState } from "react";
import { Box, Stack, Typography } from "@mui/material";
import Chips from "components/Chips";

const PolicyFilter = ({ availablePolicies, onFilterChange }) => {
  const [filterOptions, setFilterOptions] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState("All");

  useEffect(() => {
    const generateFilterOptions = () => {
      let options = [{ label: "All", value: "All" }];
      if (availablePolicies && availablePolicies.length !== 0) {
        availablePolicies.forEach((policy) => {
          if (["PLA", "CAB"].includes(policy.categoryOfWorkName)) {
            let optionLabel;
            if (policy.year && policy.quarter) {
              optionLabel = `${policy.categoryOfWorkName} - ${policy.year} - ${policy.quarter}`;
            } else {
              optionLabel = `${policy.categoryOfWorkName} - No  Date`;
            }

            if (!options.some((o) => o.label === optionLabel)) {
              options.push({ label: optionLabel, value: optionLabel });
            }
          }

          // if (
          //   ["ICD-10", "HCPCS", "Variance", "Retire"].includes(
          //     policy.categoryOfWorkName
          //   )
          // ) {
          //   foundOther = true;
          // }

          // if (policy.categoryOfWorkName === "BreakFix") {
          //   foundBreakFix = true;
          // }
        });
        options.push({ label: "Break Fix", value: "BreakFix" });
        options.push({ label: "Other", value: "Other" });
        setFilterOptions(options);
      }
    };

    generateFilterOptions();
  }, [availablePolicies]);

  const handleFilterChange = (data) => {
    setSelectedFilter(data.value);
    onFilterChange(data.value);
  };

  return (
    <Stack direction="row" spacing={1} sx={{ mb: 1, flexWrap: "wrap" }}>
      <Typography variant="subtitle1" sx={{ minWidth: 50, fontWeight: "bold" }}>
        By Type:
      </Typography>
      <Stack spacing={1}>
        {filterOptions.length > 0 && (
          <Chips
            values={filterOptions.slice(0, 5).map((option) => ({
              ...option,
              selected: selectedFilter === option.value,
            }))}
            activeFilter={selectedFilter}
            selectedFilter={handleFilterChange}
          />
        )}
        {filterOptions.length > 5 && (
          <Chips
            values={filterOptions.slice(5).map((option) => ({
              ...option,
              selected: selectedFilter === option.value,
            }))}
            activeFilter={selectedFilter}
            selectedFilter={handleFilterChange}
          />
        )}
      </Stack>
    </Stack>
  );
};

export default PolicyFilter;
